export const DOM_ID = {
  IFRAME_CONTAINER: 'iframe-container',
} as const
